// Support default import pattern from js-utils
import { setupI18n } from './js-utils-i18n';
import interpolate from '@eb/interpolate-lazy-string';
import context from './context';

const { gettext: _gettext } = setupI18n(context);

export default function jsUtilsGettextShim(...args) {
    /* i18next-extract-disable-next-line */
    const preInterpolatedString = _gettext(...args);

    // Unlike for lazy-gettext, we want to call interpolate first.
    // For new uses of gettext from this package, don't call interpolate on the string.
    // This is just here to support legacy use cases.
    return interpolate(preInterpolatedString);
}

export const gettext = jsUtilsGettextShim;
